import { Identifier } from 'types/utilityTypes';

export enum BillingStatus {
  Pending = 'Pending',
  Billed = 'Billed',
  Paid = 'Paid',
  NonBilled = 'Non-Billed',
  Frozen = 'Frozen',
  Inactive = 'Inactive',
  PendingCancellation = 'Pending Cancellation',
}

export enum EmailType {
  ManualMigration = 'manual_migration',
}

export interface Client {
  id: Identifier;
  clientId: Identifier;
  userId: Identifier;
  tags?: string[];
  firstName: string;
  lastName: string;
  clientPhoneNumber: string;
  clientImage: string;
  clientName: string;
  clientEmail: string;
  subTrainerId: Identifier | null;
  files?: ClientFile[];
  billingStatus: BillingStatus;
  failedPayment: boolean;
  trainerIds?: Identifier[];

  // nutritionDate
  restCarbs: number;
  restFat: number;
  restProtein: number;
  restFiber: number;
  restCarbsMacro: number;
  restFatMacro: number;
  restProteinMacro: number;
  restFiberMacro: number;
  restCalories: number;

  goalCarbs: number;
  goalFat: number;
  goalProtein: number;
  goalFiber: number;
  goalCarbsMacro: number;
  goalFatMacro: number;
  goalProteinMacro: number;
  goalFiberMacro: number;
  goalCalories: number;

  lifecycleStageId: number;
  lifecycleStageName: 'string';

  measurementNotes: string;
  nutritionNotes: string;
  calculateCalories: boolean;

  calendarClientId: Identifier;
  /** When true, the client does not receive SMS (maps to `sms_opted_out` on the user). */
  smsOptedOut?: boolean;
  disableAllAccountEmails: boolean;
  showStatus: boolean;
  statusName: string;
  cancelPending: boolean;
  pendingSubscription: boolean;
  hasSubscription: boolean;
  hasPurchase: boolean;
  nextPayment: {
    date: Date;
    invoice: {
      amountDue: number;
    };
  };
}

export interface ClientFile {
  id: number;
  name: string;
  contentType: string;
  link: string;
  type: 'paperclip' | 'nutrition_file';
}
